const teesModalApp = function () {
  const roundSelect = document.querySelector('.round-type-cards-signs');
  const teeFilterValue = document.getElementById('tee-filter-value');
  const teeFilterOption = document.getElementById('tee-filter-option');
  const teeFilterDisplay = document.getElementById('tee-filter-display');
  const teeFilterText = document.getElementById('tee-filter-text');
  const saveTeeFilterBtn = document.getElementById('save-tee-filter');
  const teeOptionsContainer = document.getElementById('tee-options-container');
  const leagueId = gon.league_id;

  const teeFilterOptions = {
    all_tees: 'All tees',
    only_used_tees: 'Only used tees'
  };
  const teeFilterModalError = document.getElementById('tee-filter-modal-error');

  function hasTeeSelection() {
    const value = (teeFilterValue.value || '').trim();
    const option = ((teeFilterOption && teeFilterOption.value) || '').trim();

    if (value === 'no_tees' || option === 'no_tees') return false;
    if (['all_tees', 'only_used_tees'].indexOf(value) !== -1) return true;
    if (['all_tees', 'only_used_tees'].indexOf(option) !== -1) return true;

    return value.split(',').map(function(token) { return token.trim(); }).filter(Boolean).length > 0;
  }

  function setFieldError(visible) {
    teeFilterDisplay.classList.toggle('is-invalid', visible);
  }

  function setModalError(visible) {
    if (teeFilterModalError) teeFilterModalError.classList.toggle('d-none', !visible);
  }

  function updateDisplayText() {
    const value = teeFilterValue.value;

    if (!value || value === '' || value === 'no_tees') {
      teeFilterText.textContent = 'Select tees';
      return;
    }

    // Check if it's a predefined option
    if (teeFilterOptions[value]) {
      teeFilterText.textContent = teeFilterOptions[value];
      return;
    }

    // Specific tees (comma-separated colors)
    const selectedTokens = value.split(',').map(v => v.trim()).filter(v => v !== '');
    if (selectedTokens.length > 0) {
      const teeNames = [];
      selectedTokens.forEach(token => {
        const checkbox = document.getElementById(`specific_tee_${token}`) ||
          document.querySelector(`.tee-filter-checkbox[data-tee-color="${token}"]`);
        if (checkbox) {
          teeNames.push(checkbox.dataset.teeName);
        }
      });

      if (teeNames.length === 1) {
        teeFilterText.textContent = teeNames[0];
      } else if (teeNames.length > 1) {
        teeFilterText.textContent = `${teeNames.length} tees selected`;
      } else {
        teeFilterText.textContent = 'Select tees';
      }
    }
  }

  function loadTeesForRound() {
    const roundId = roundSelect.value;

    if (!roundId) {
      teeOptionsContainer.innerHTML = '<p class="text-warning">Please select a round first</p>';
      return;
    }

    teeOptionsContainer.innerHTML = '<div class="spinner-border text-primary mx-auto d-block"><span class="sr-only">Loading...</span></div>';

    // Fetch tees for this round
    fetch(`/leagues/${leagueId}/cards_signs/${roundId}/tees.json`)
      .then(response => response.json())
      .then(data => {
        renderTeeOptions(data.tees);
      })
      .catch(error => {
        console.error('Error loading tees:', error);
        teeOptionsContainer.innerHTML = '<p class="text-danger">Error loading tees</p>';
      });
  }

  function renderTeeOptions(tees) {
    let html = '<div class="form-group">';

    // Add filter options
    html += '<label class="d-block mb-3"><strong>Tee Selection:</strong></label>';
    Object.entries(teeFilterOptions).forEach(([key, label]) => {
      const isChecked = teeFilterValue.value === key ? 'checked' : '';
      html += `
        <div class="form-check mb-2">
          <input class="material-inputs filled-in form-check-input chk-col-primary tee-filter-radio" type="radio" name="tee_filter_option" value="${key}" id="tee_${key}" ${isChecked}>
          <label class="form-check-label" for="tee_${key}">${label}</label>
        </div>
      `;
    });

    // Add specific tees if available
    if (tees && tees.length > 0) {
      html += '<hr><label class="d-block mb-3"><strong>Specific Tees:</strong></label>';
      const selectedTokens = teeFilterValue.value.split(',').map(v => v.trim()).filter(v => v !== '');
      tees.forEach(tee => {
        const isChecked = selectedTokens.includes(String(tee.id)) ||
          selectedTokens.includes(String(tee.color)) ? 'checked' : '';
        html += `
          <div class="form-check mb-2">
            <input class="material-inputs filled-in form-check-input chk-col-primary tee-filter-checkbox" type="checkbox" value="${tee.id}" id="specific_tee_${tee.id}" ${isChecked} data-tee-name="${tee.name}" data-tee-color="${tee.color}">
            <label class="form-check-label" for="specific_tee_${tee.id}">${tee.name}</label>
          </div>
        `;
      });
    }

    html += '</div>';
    teeOptionsContainer.innerHTML = html;
    attachTeeFilterListeners();
    updateDisplayText();
  }

  function attachTeeFilterListeners() {
    document.querySelectorAll('.tee-filter-radio').forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          teeFilterValue.value = this.value;
          if (teeFilterOption) teeFilterOption.value = this.value;
          document.querySelectorAll('.tee-filter-checkbox').forEach(cb => cb.checked = false);
          if (hasTeeSelection()) {
            setModalError(false);
            setFieldError(false);
          }
        }
      });
    });

    document.querySelectorAll('.tee-filter-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        document.querySelectorAll('.tee-filter-radio').forEach(r => r.checked = false);
        updateSpecificTeesValue();
      });
    });
  }

  function updateSpecificTeesValue() {
    const selectedTees = Array.from(document.querySelectorAll('.tee-filter-checkbox:checked'))
      .map(cb => cb.value)
      .join(',');
    teeFilterValue.value = selectedTees;
    if (teeFilterOption) {
      teeFilterOption.value = selectedTees ? 'specific_tees' : '';
    }
    if (hasTeeSelection()) {
      setModalError(false);
      setFieldError(false);
    }
  }

  teeFilterDisplay.addEventListener('click', loadTeesForRound);

  saveTeeFilterBtn.addEventListener('click', function() {
    if (!hasTeeSelection()) {
      setModalError(true);
      setFieldError(true);
      return;
    }

    setModalError(false);
    setFieldError(false);
    updateDisplayText();
    $('#tee-filter-modal').modal('hide');
  });

  // Use jQuery event for Select2 compatibility
  $('.round-type-cards-signs').on('change', function() {
    if (!teeFilterValue.value) {
      teeFilterValue.value = 'only_used_tees';
    }
    if (teeFilterOption && !teeFilterOption.value) {
      teeFilterOption.value = 'only_used_tees';
    }
    updateDisplayText();
    // Reset modal content so it loads fresh tees for the new round
    teeOptionsContainer.innerHTML = '<div class="spinner-border text-primary mx-auto d-block"><span class="sr-only">Loading...</span></div>';
  });

  // Initialize display text
  updateDisplayText();

  $(".submit-scorecard").on("click", function (e) {
    if (!hasTeeSelection()) {
      e.preventDefault();
      setFieldError(true);
      if (window.toastr) toastr.error("Select at least one tee to display.");
      return;
    }

    $(".generic-loader").removeClass("d-none");
    setTimeout(hideGenericLoader, 1500);
  });
};

const hideGenericLoader = () => $(".generic-loader").addClass("d-none");

$(document).on("turbolinks:load", function () {
  if (!$("body").hasClass("controller-leagues-cards_signs")) return;

  window.addEventListener("pageshow", hideGenericLoader);

  $(".round-type-cards-signs").select2().trigger("change");
  $(".select-cards-per-page").select2({ minimumResultsForSearch: -1 });
  $(".select-cards-dots").select2({ minimumResultsForSearch: -1 });
  $(".select-line-options").select2({ minimumResultsForSearch: -1 });
  $(".select-format-type").select2({ minimumResultsForSearch: -1 });

  $(".select-line-options")
    .on("change", function () {
      if ($(this).val() == "no_extra") $(".extra-line-text-group").addClass("d-none");
      else $(".extra-line-text-group").removeClass("d-none");
    })
    .trigger("change");

  setTimeout(() => {
    $("select.custom-select, select.select2").trigger("change");
  }, 200);

  $("a#remove-logo").on("click", function (e) {
    window.stopEvent(e);

    $(this).parent().find("input").val("true");
    $("#card-image").attr("src", "");
    $(this).addClass("d-none");
    $("input[type=file].custom-file").val("");
  });

  $("input[type=file].custom-file").on("change", function (e) {
    if (e.target.files.length > 0) {
      $("a#remove-logo").parent().find("input").val("");
    }
  });

  teesModalApp();
});
